import logo1 from "../../assets/img/ple/summerslam/88.png";
import logo2 from "../../assets/img/ple/summerslam/89.png";
import logo3 from "../../assets/img/ple/summerslam/90.png";
import logo4 from "../../assets/img/ple/summerslam/91.png";
import logo5 from "../../assets/img/ple/summerslam/92.png";
import logo6 from "../../assets/img/ple/summerslam/93.png";
import logo7 from "../../assets/img/ple/summerslam/94.png";
import logo8 from "../../assets/img/ple/summerslam/95-96.png";
import logo9 from "../../assets/img/ple/summerslam/97.png";
import logo10 from "../../assets/img/ple/summerslam/98.png";
import logo11 from "../../assets/img/ple/summerslam/99.png";
import logo12 from "../../assets/img/ple/summerslam/2000.png";
import logo13 from "../../assets/img/ple/summerslam/2001.png";
import logo14 from "../../assets/img/ple/summerslam/2002.png";
import logo15 from "../../assets/img/ple/summerslam/2003.png";
import logo16 from "../../assets/img/ple/summerslam/2004.png";
import logo17 from "../../assets/img/ple/summerslam/2005.png";
import logo18 from "../../assets/img/ple/summerslam/2006-2007.png";
import logo19 from "../../assets/img/ple/summerslam/2008.png";
import logo20 from "../../assets/img/ple/summerslam/2009.png";
import logo21 from "../../assets/img/ple/summerslam/2010-2011.png";
import logo22 from "../../assets/img/ple/summerslam/2012.png";
import logo23 from "../../assets/img/ple/summerslam/2013.png";
import logo24 from "../../assets/img/ple/summerslam/2014-2021.png";
import logo25 from "../../assets/img/ple/summerslam/2022.png";
import logo26 from "../../assets/img/ple/summerslam/2023.png";
import logo27 from "../../assets/img/ple/summerslam/2024.png";
import logo28 from "../../assets/img/ple/summerslam/2025.png";
import logo29 from "../../assets/img/ple/summerslam/2026.png";

export const summerSlamDetail = {
  id: "summerslam",
  title: "SummerSlam",
  subtitle: "Explore event editions in a dedicated event view.",
  tabs: [
    {
      id: "logos",
      label: "Editions",
      variant: "summerslam",
      items: [
        {
          id: "summerslam-logo-main",
          title: "SummerSlam",
          description: "Where the Mega Powers Meet the Mega Bucks 1988",
          imgUrl: logo1,
        },
        {
          id: "summerslam-logo-89",
          title: "SummerSlam",
          description: "Feel The Heat! 1989",
          imgUrl: logo2,
        },
        {
          id: "summerslam-logo-90",
          title: "SummerSlam",
          description: "The Heat Returns 1990",
          imgUrl: logo3,
        },
        {
          id: "summerslam-logo-91",
          title: "SummerSlam",
          description: "A Match Made in Heaven, A Match Made in Hell 1991",
          imgUrl: logo4,
        },
        {
          id: "summerslam-logo-92",
          title: "SummerSlam",
          description: "The SummerSlam You Thought You´d Never See! 1992",
          imgUrl: logo5,
        },
        {
          id: "summerslam-logo-93",
          title: "SummerSlam",
          description: "Fat Chance! Somebody Has to Stop Him! 1993",
          imgUrl: logo6,
        },
        {
          id: "summerslam-logo-94",
          title: "SummerSlam",
          description: "So Hot It´s Scary 1994",
          imgUrl: logo7,
        },
        {
          id: "summerslam-logo-95",
          title: "SummerSlam",
          description: "Face The Heat 1995",
          imgUrl: logo8,
        },
        {
          id: "summerslam-logo-96",
          title: "SummerSlam",
          description: "Opposites Attack! 1996",
          imgUrl: logo8,
        },
        {
          id: "summerslam-logo-97",
          title: "SummerSlam",
          description: "Hart & Soul 1997",
          imgUrl: logo9,
        },
        {
          id: "summerslam-logo-98",
          title: "SummerSlam",
          description: "Highway to Hell 1998",
          imgUrl: logo10,
        },
        {
          id: "summerslam-logo-99",
          title: "SummerSlam",
          description: "An Out of Body Experience 1999",
          imgUrl: logo11,
        },
        {
          id: "summerslam-logo-2000",
          title: "SummerSlam",
          description: "2000",
          imgUrl: logo12,
        },
        {
          id: "summerslam-logo-2001",
          title: "SummerSlam",
          description: "Finally. 2001",
          imgUrl: logo13,
        },
        {
          id: "summerslam-logo-2002",
          title: "SummerSlam",
          description: "2002",
          imgUrl: logo14,
        },
        {
          id: "summerslam-logo-2003",
          title: "SummerSlam",
          description: "2003",
          imgUrl: logo15,
        },
        {
          id: "summerslam-logo-2004",
          title: "SummerSlam",
          description: "Let The Games Begin 2004",
          imgUrl: logo16,
        },
        {
          id: "summerslam-logo-2005",
          title: "SummerSlam",
          description: "Hogan vs. Michaels: For the First Time Ever. 2005",
          imgUrl: logo17,
        },
        {
          id: "summerslam-logo-2006",
          title: "SummerSlam",
          description: "The Biggest Party of the Summer 2006",
          imgUrl: logo18,
        },
        {
          id: "summerslam-logo-2007",
          title: "SummerSlam",
          description: "The Party Is Over 2007",
          imgUrl: logo18,
        },
        {
          id: "summerslam-logo-2008",
          title: "SummerSlam 2008",
          description: "The Biggest BlockBuster Of The Summer 2008",
          imgUrl: logo19,
        },
        {
          id: "summerslam-logo-2009",
          title: "SummerSlam",
          description: "The Biggest Event of the Summer 2009",
          imgUrl: logo20,
        },
        {
          id: "summerslam-logo-2010",
          title: "SummerSlam",
          description: "2010",
          imgUrl: logo21,
        },
        {
          id: "summerslam-logo-2011",
          title: "SummerSlam",
          description: "The Biggest Party of the Summer 2011",
          imgUrl: logo21,
        },
        {
          id: "summerslam-logo-2012",
          title: "SummerSlam",
          description: "The Perfect Storm 2012",
          imgUrl: logo22,
        },
        {
          id: "summerslam-logo-2013",
          title: "SummerSlam",
          description: "2013",
          imgUrl: logo23,
        },
        {
          id: "summerslam-logo-2014-2019",
          title: "SummerSlam",
          description: "2014 - 2019",
          imgUrl: logo24,
        },
        {
          id: "summerslam-logo-2020",
          title: "SummerSlam",
          description: "You'll Never See It Coming 2020",
          imgUrl: logo24,
        },
        {
          id: "summerslam-logo-2021",
          title: "SummerSlam",
          description: "Your Summer Vacation Destination 2021",
          imgUrl: logo24,
        },
        {
          id: "summerslam-logo-2022",
          title: "SummerSlam",
          description: "2022",
          imgUrl: logo25,
        },
        {
          id: "summerslam-logo-2023",
          title: "SummerSlam",
          description: "Detroit 2023",
          imgUrl: logo26,
        },
        {
          id: "summerslam-logo-2024",
          title: "SummerSlam",
          description: "Cleveland 2024",
          imgUrl: logo27,
        },
        {
          id: "summerslam-logo-2025",
          title: "SummerSlam",
          description: "New Jersey 2025",
          imgUrl: logo28,
        },
        {
          id: "summerslam-logo-2026",
          title: "SummerSlam",
          description: "Minneapolis 2026",
          imgUrl: logo29,
        },
      ],
    },
  ],
};
